import { render, staticRenderFns } from "./Sharpgamma.vue?vue&type=template&id=60f796b1&"
import script from "./Sharpgamma.vue?vue&type=script&lang=js&"
export * from "./Sharpgamma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Sharpgamma.vue"
export default component.exports